import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from './HashMap.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmptyHolderClass;
function EmptyHolder() {
  if (EmptyHolderClass === VOID) {
    class $ {
      constructor() {
        EmptyHolder_instance = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = InternalHashMap().new_kotlin_collections_InternalHashMap_jnbws6_k$(0);
        this_0.build_52xuhq_k$();
        tmp.value_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_23ju8i_k$(this_0);
      }
    }
    initMetadataForObject($, 'EmptyHolder');
    EmptyHolderClass = $;
  }
  return EmptyHolderClass;
}
var EmptyHolder_instance;
function EmptyHolder_getInstance() {
  if (EmptyHolder_instance === VOID)
    new (EmptyHolder())();
  return EmptyHolder_instance;
}
function init_kotlin_collections_LinkedHashMap(_this__u8e3s4) {
}
var LinkedHashMapClass;
function LinkedHashMap() {
  if (LinkedHashMapClass === VOID) {
    class $ extends HashMap() {
      static new_kotlin_collections_LinkedHashMap_ga0any_k$() {
        var $this = this.new_kotlin_collections_HashMap_2a5kxx_k$();
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static new_kotlin_collections_LinkedHashMap_31p40q_k$(initialCapacity) {
        var $this = this.new_kotlin_collections_HashMap_5ewlp_k$(initialCapacity);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static new_kotlin_collections_LinkedHashMap_40dkn3_k$(original) {
        var $this = this.new_kotlin_collections_HashMap_gc38m_k$(original);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static new_kotlin_collections_LinkedHashMap_23ju8i_k$(internalMap) {
        var $this = this.new_kotlin_collections_HashMap_xg4pkp_k$(internalMap);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      build_nmwvly_k$() {
        this.internalMap_1.build_52xuhq_k$();
        var tmp;
        if (this.get_size_woubt6_k$() > 0) {
          tmp = this;
        } else {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = EmptyHolder_getInstance().value_1;
        }
        return tmp;
      }
      checkIsMutable_jn1ih0_k$() {
        return this.internalMap_1.checkIsMutable_h5js84_k$();
      }
    }
    initMetadataForClass($, 'LinkedHashMap', $.new_kotlin_collections_LinkedHashMap_ga0any_k$, VOID, [KtMutableMap()]);
    LinkedHashMapClass = $;
  }
  return LinkedHashMapClass;
}
//region block: exports
export {
  LinkedHashMap as LinkedHashMap1zhqxkxv3xnkl,
};
//endregion

//# sourceMappingURL=LinkedHashMap.mjs.map
